import logger from '../log';

const log = logger.getLogger(__filename);

export enum ProxyType {
  EDGE_CACHE = 'EdgeCache'
}

export interface ProxyConfig {
  // This value describes the type of proxy and allows the sdk to dispatch to the appropriate implementation.
  proxyType: ProxyType;
  // allows for disabling a config like is done with agents.
  disabled: boolean;
  // hostname for proxy service
  host: string;
  // the scheme prefix for requests. Expected values at this time are http and https
  scheme: string;
  // the timeout expected for requests to the proxy. This is the total time the sdk should wait for payloads.
  timeout: number;
}

export interface MaybeProxyConfig {
  // This value describes the type of proxy and allows the sdk to dispatch to the appropriate implementation.
  proxyType?: string;
  // allows for disabling a config like is done with agents.
  disabled?: boolean;
  // hostname for proxy service
  host?: string;
  // the scheme prefix for requests. Expected values at this time are http and https
  scheme?: string;
  // the timeout expected for requests to the proxy. This is the total time the sdk should wait for payloads.
  timeout?: number;
}

export default function proxyConfig(
  proxy?: MaybeProxyConfig
): ProxyConfig | undefined {
  if (!proxy || !proxy.proxyType || !proxy.host || !proxy.scheme) {
    return undefined;
  }
  if (proxy.proxyType !== ProxyType.EDGE_CACHE) {
    log.error(
      `Unknown proxy config type: ${proxy.proxyType}. Dropping proxy config.`
    );
    return undefined;
  }
  const p = {
    // casting the string to the string tells tsc that we want it to be of the expected type,
    // not just a string. However, using the expected type union would convert any string to the wrong type.
    proxyType: ProxyType.EDGE_CACHE,
    disabled: proxy.disabled || false,
    timeout: proxy.timeout || 3,
    host: proxy.host,
    scheme: proxy.scheme
  };

  return p;
}
